$(document).ready(function () {
	let tmPromocode;
	$(document).on('input change', '.promocode #promo_code', function () {
		var params = $(this).data();
		params.promocode = $(this).val();

		if (params.upgrade) {
			params.tariff_id = $(this).closest('form').find('[name=tariff_id]:checked').val();
		}

		if (params.service) {
			params.add_service_price_id =  $(this).closest('form').find('[name=price_type_id]:checked').val();
		}

		let $container = $(this).closest('.promocode');
		let $modalBuy = $container.closest('.modal-buy');

		let $sum = $modalBuy.find('.sum');

		if (!params.promocode) {
			$container.find('.success-msg, .error-msg').hide();
			$sum.removeClass('discounted');
		} else {
			clearTimeout(tmPromocode);
			tmPromocode =  setTimeout(function () {
				$.get('/cart/check_promocode', params, function (data) {
					$container.find('.success-msg, .error-msg').hide();

					if (data.error) {
						$container.find('.error-msg').html(data.msg).show();
						$sum.removeClass('discounted');
					} else {
						if (data.discount) {
							$container.find('.success-msg .text').html('Скидка по промокоду:');
							$container.find('.success-msg .discount').html(data.discount).show();

							$sum.find('.sum-default').text(output_money(data.calculated.sum_products));
							$sum.find('.sum-discounted').text(output_money(data.calculated.sum));
							$sum.addClass('discounted');
						} else {
							$container.find('.success-msg .text').html('Промокод действителен');
							$container.find('.success-msg .discount').hide();
						}

						$container.find('.success-msg').show();
						$container.find('.set-promocode').show();
					}
				});
			}, 100);
		}

		return false;
	});
});